import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface SegmentedOption<T extends string = string> {
  id:    T;
  label: string;
  /** Optional icon src rendered before the label. */
  icon?: string;
}

/**
 * Pill-shaped segmented control (e.g. "Top | 3D" above the holes map).
 * Design source : Figma 2544:670377 ("View")
 */
@Component({
  selector:        'app-segmented-control',
  standalone:      true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls:       ['./segmented-control.component.scss'],
  template: `
    <div class="segmented" role="tablist">
      @for (option of options(); track option.id) {
        <button
          type="button"
          role="tab"
          class="segmented__btn"
          [class.segmented__btn--active]="option.id === value()"
          [attr.aria-selected]="option.id === value()"
          [attr.data-attr]="dataAttrPrefix() ? dataAttrPrefix() + '-' + option.id : null"
          (click)="select(option.id)">
          @if (option.icon) {
            <img class="segmented__icon" [src]="option.icon" alt="">
          }
          <span class="segmented__label">{{ option.label }}</span>
        </button>
      }
    </div>
  `,
})
export class SegmentedControlComponent {
  readonly options        = input.required<SegmentedOption[]>();
  readonly value          = input<string | null>(null);
  /** Playwright hook prefix: renders `data-attr="<prefix>-<optionId>"` on each button. */
  readonly dataAttrPrefix = input<string>('');

  readonly valueChange = output<string>();

  protected select(id: string): void {
    if (id !== this.value()) this.valueChange.emit(id);
  }
}
